// Port of api/fuel/app/classes/insights/game/playercount.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'playercount',
    priority: 6,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.has_plays) return {}

        var game = this._data.game
        var playsRaw = this._data.plays_raw

        var data = {
            yours: {},
            community: {},
            bestCount: null,
            yourMostCommon: null
        }

        // Your play distribution by player count
        var yours = {}

        for (var i = 0; i < playsRaw.length; i++) {
            var playerCount = parseInt(playsRaw[i].play_players, 10) || 0
            if (playerCount > 0) {
                if (!yours[playerCount]) yours[playerCount] = 0
                yours[playerCount] += parseInt(playsRaw[i].play_count, 10) || 0
            }
        }

        data.yours = yours

        // Your most common player count
        var yoursKeys = Object.keys(yours)
        if (yoursKeys.length > 0) {
            var maxCount = 0
            var mostCommon = null

            for (var yi = 0; yi < yoursKeys.length; yi++) {
                var count = parseInt(yoursKeys[yi], 10)
                if (yours[count] > maxCount) {
                    maxCount = yours[count]
                    mostCommon = count
                }
            }
            data.yourMostCommon = mostCommon
        }

        // Community poll data from game model
        var communityData = game.get_players_community()

        if (communityData) {
            if (typeof communityData === 'string') {
                try { communityData = JSON.parse(communityData) } catch (e) { communityData = null }
            }

            if (communityData && typeof communityData === 'object') {
                var community = {}
                var bestVotes = 0
                var bestCount = null

                var cdKeys = Object.keys(communityData)
                for (var ci = 0; ci < cdKeys.length; ci++) {
                    var cnt = cdKeys[ci]
                    var votes = communityData[cnt]
                    var b = (votes && votes.b) ? parseInt(votes.b, 10) : 0
                    var r = (votes && votes.r) ? parseInt(votes.r, 10) : 0
                    var n = (votes && votes.n) ? parseInt(votes.n, 10) : 0

                    community[cnt] = {
                        best: b,
                        recommended: r,
                        notRecommended: n
                    }

                    if (b > bestVotes) {
                        bestVotes = b
                        bestCount = parseInt(cnt, 10)
                    }
                }

                data.community = community
                data.bestCount = bestCount
            }
        }

        return {
            playercount: data
        }

    }
})
